/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetMiscTimestampRequest = { ts: string };

export const GetMiscTimestampRequest$zodSchema: z.ZodType<
  GetMiscTimestampRequest
> = z.object({
  ts: z.string().describe(
    "需要转换的Unix时间戳，支持10位（秒）或13位（毫秒）。",
  ),
});

export type GetMiscTimestampDetails = {};

export const GetMiscTimestampDetails$zodSchema: z.ZodType<
  GetMiscTimestampDetails
> = z.object({});

/**
 * 无效的时间戳参数。请检查 `ts` 参数是否为纯数字字符串。
 */
export type GetMiscTimestampBadRequestResponseBody = {
  code?: string | undefined;
  details?: GetMiscTimestampDetails | undefined;
  message?: string | undefined;
};

export const GetMiscTimestampBadRequestResponseBody$zodSchema: z.ZodType<
  GetMiscTimestampBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetMiscTimestampDetails$zodSchema).optional(),
  message: z.string().optional(),
}).describe("无效的时间戳参数。请检查 `ts` 参数是否为纯数字字符串。");

/**
 * 转换成功！
 */
export type GetMiscTimestampResponseBody = {
  datetime_local?: string | undefined;
  datetime_utc?: string | undefined;
  input?: string | undefined;
  type?: string | undefined;
  unix_timestamp?: number | undefined;
};

export const GetMiscTimestampResponseBody$zodSchema: z.ZodType<
  GetMiscTimestampResponseBody
> = z.object({
  datetime_local: z.string().optional(),
  datetime_utc: z.string().optional(),
  input: z.string().optional(),
  type: z.string().optional(),
  unix_timestamp: z.int().optional(),
}).describe("转换成功！");

export type GetMiscTimestampResponse =
  | GetMiscTimestampResponseBody
  | GetMiscTimestampBadRequestResponseBody;

export const GetMiscTimestampResponse$zodSchema: z.ZodType<
  GetMiscTimestampResponse
> = z.union([
  z.lazy(() => GetMiscTimestampResponseBody$zodSchema),
  z.lazy(() => GetMiscTimestampBadRequestResponseBody$zodSchema),
]);
